import { render, staticRenderFns } from "./RestoreButton.vue?vue&type=template&id=1556fee8"
import script from "./RestoreButton.vue?vue&type=script&lang=ts"
export * from "./RestoreButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports